/*
 * @Date: 2020-09-09 11:17:17
 * @LastEditors: guantingting
 * @LastEditTime: 2021-04-21 16:19:47
 */

export default function ({ url, data, method = 'POST', async = true }) {
  return new Promise((resolve,reject)=>{
    const xmlhttp = new XMLHttpRequest();
    //针对FireFox、Mozillar、Opera、Safari、IE7、IE8
    //修正某些mozillar浏览器的BUG
    if (window.XMLHttpRequest && xmlhttp.overrideMimeType) {
      xmlhttp.overrideMimeType('text/html')
    }
    if (xmlhttp != null) {
      xmlhttp.open(method, url, !!async);
      // xmlhttp.setRequestHeader("Content-Type","application/json");
      // xmlhttp.withCredentials = true;
      xmlhttp.send(data?JSON.stringify([data]): '')
      xmlhttp.onloadend = function() {
        if(xmlhttp.status == 404) {
          reject('请求地址404')
        } 
      }
      xmlhttp.onreadystatechange = function(){
        if(this.readyState == 4){
          if(this.response){
            let res = JSON.parse(this.response);
            resolve(res);
          }else{
            reject(null);
          }
        }
      }
    } else {
      // throw new Error('xmlhttp无法创建，埋点上报失败')
      reject('xmlhttp无法创建')
    }
  });
}
